<template>
  <d3-chart v-show="isShowPsiBoxPlot"
              :options="psiChartOptions"></d3-chart>
</template>

<script>
import { getPancancerPSIByEventID } from 'node/splicevis.js'
export default {
  name: 'EventPancancerPsi',
  data() {
    return {
      isShowPsiBoxPlot: true,
      event_id: null,
      psiChartOptions: {
        chart: {
          type: 'boxplot'
        },
        title: {
          text: ''
        },
        legend: {
          enabled: false
        },
        xAxis: {
          categories: [],
          labels: {
            style: {
              'font-family': '"Roboto", sans-serif',
              'font-size': 12,
              'font-weight': '',
            }
          }
        },
        yAxis: {
          title: {
            text: 'PSI Value',
            style: {
              'font-family': '"Roboto", sans-serif',
              'font-size': 12,
              'font-weight': '',
            }
          }
        },
        plotOptions: {
          boxplot: {
            // fillColor: '#F0F0E0',
            lineWidth: 2,
            // medianColor: '#0C5DA5',
            medianColor: '#757575',
            medianWidth: 2,
            stemColor: '#A63400',
            stemDashStyle: 'dot',
            stemWidth: 1,
            whiskerColor: '#3D9200',
            whiskerLength: '20%',
            whiskerWidth: 3,

            fillColor: null,
            colorByPoint: true,
            colors: ["#EF9A9A", "#EF9A9A", "#90CAF9", "#EF9A9A", "#90CAF9", "#EF9A9A", "#90CAF9", "#EF9A9A", "#90CAF9",
              "#EF9A9A", "#90CAF9", "#EF9A9A", "#EF9A9A", "#90CAF9", "#EF9A9A", "#EF9A9A", "#90CAF9", "#EF9A9A",
              "#90CAF9", "#EF9A9A", "#90CAF9", "#EF9A9A", "#90CAF9", "#EF9A9A", "#EF9A9A", "#EF9A9A", "#90CAF9",
              "#EF9A9A", "#90CAF9", "#EF9A9A", "#90CAF9", "#EF9A9A", "#EF9A9A", "#EF9A9A", "#90CAF9", "#EF9A9A",
              "#90CAF9", "#EF9A9A", "#90CAF9", "#EF9A9A", "#90CAF9", "#EF9A9A", "#90CAF9", "#EF9A9A", "#90CAF9",
              "#EF9A9A", "#90CAF9", "#EF9A9A", "#EF9A9A", "#90CAF9", "#EF9A9A", "#90CAF9", "#EF9A9A", "#90CAF9",
              "#EF9A9A", "#EF9A9A"],
          }
        },
        series: [{
          name: 'PSI',
          data: [],
          tooltip: {
            headerFormat: '{point.key}<br/>',
            style: {
              'font-family': 'Arial',
              'font-size': 10,
              'font-weight': 'bold',
            }
          }
        }, {
          name: 'PSI',
          type: 'scatter',
          data: [],
          jitter: {
            x: 0.24 // Exact fit for box plot's groupPadding and pointPadding
          },
          marker: {
            radius: 1
          },
          color: 'rgba(100, 100, 100, 0.5)',
          tooltip: {
            pointFormat: 'Value: {point.y}'
          }
        }],
        credits: {
          enabled: false
        },
      },
    }
  },
  props: {
    eventId: {
      type: String,
      default() {
        return
      }
    }
  },
  watch: {
    eventId(newVal, oldVal) {
      // console.log(newVal, oldVal);
      this.event_id = newVal;

      getPancancerPSIByEventID(this.event_id).then((data) => {
        // console.log(data);
        if (data.length > 0) {
          this.isShowPsiBoxPlot = true;
          this.$emit('isshow', this.isShowPsiBoxPlot);
          let categories = [];
          let boxplotData = [];
          let cancer_psi_boxplot = data[0].cancer_psi_boxplot;
          Object.keys(cancer_psi_boxplot).forEach((v, i, a) => {
            categories.push(v);
            boxplotData.push(cancer_psi_boxplot[v])
          });
          // console.log(categories);
          // console.log(boxplotData);
          this.psiChartOptions.xAxis.categories = categories;
          this.psiChartOptions.series[0].data = boxplotData;
        } else {
          this.isShowPsiBoxPlot = false;
          this.$emit('isshow', this.isShowPsiBoxPlot);
        }
      }).catch((err) => {
        console.error(err);
      });
    }
  },
  methods: {
  },
}
</script>
<style scoped lang="sass">
.v-card__title
  line-height: 0.5rem
</style>
